<template>
  <iframe
    class="hmt-lazy-loading"
    :data-src="`${url}?setAttribution=mls`"
    allowfullscreen
    frameborder="0"
	>
  </iframe>
</template>

<script>
  import lazyLoading from '@/shared/utils/lazy-loading'

	export default {
		props: {
      url: {
        default: '',
        type: String
      }
    },
    mounted () {
      lazyLoading()
    }
	}
</script>
